module.exports = __webpack_public_path__ + "media/alaska/plane_track-5dd7136f.jpg";